import { connect } from 'react-redux';
import R from 'ramda';
import { PAGES } from '../../constants';

import { setNavigation } from '_actions';
import {
  regenerate,
  remove,
  fetchList
} from '_actions/apiTokens';
import APITokensPage from './page';

const mapStateToProps = state => ({
  apitokensPage: R.pathOr({}, ['pages', PAGES.API_TOKENS], state)
});

const mapDispatchToProps = dispatch => ({
  // actions
  onCreateAPIToken: R.compose(dispatch, fetchList, R.always({ pageName: PAGES.API_TOKENS, pageNum: 1 })),
  onRegenerateAPIToken: R.compose(dispatch, regenerate), // ({ tokenId })
  onRemoveAPIToken: R.compose(dispatch, remove), // ({ tokenId })
  onRefreshAPITokenList: R.compose(dispatch, fetchList),

  goToPage: R.compose(dispatch, setNavigation, R.merge(R.__, { pageName: PAGES.API_TOKENS })) // navigation
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(APITokensPage);



// WEBPACK FOOTER //
// ./webAdmin/components/apitokens/index.js